import React from 'react';
import { Card, Col, Row, Statistic, Spin } from 'antd';
import { DollarOutlined, TrophyOutlined, PercentageOutlined } from '@ant-design/icons';

const StatisticsCard = ({ data, loading, products }) => {
  // Local utility functions for price formatting
  const constructDisplayNumber = (number, decimal = 2) => {
    const numberWithDecimal = Number(number).toFixed(decimal);
    const numberWithDecimalAndComma = numberWithDecimal.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return numberWithDecimalAndComma;
  };

  const constructDisplayPrice = (feeAmount = 0, prefix = '') => {
    const displayFee = String(constructDisplayNumber(feeAmount));
    const displayFeeWithPrefix = prefix ? `${prefix} ${displayFee}` : displayFee;
    return displayFeeWithPrefix;
  };

  // Helper function to find value by title in the data array
  const findValueByTitle = title => {
    const item = data.find(item => item.title === title);
    return item ? item.value : 0;
  };

  // console.log(findValueByTitle('Monthly Total Billed'));

  // Extract monthly and yearly data from the data array
  const monthlyData = {
    totalBilled: findValueByTitle('Monthly Total Billed'),
    totalCollected: findValueByTitle('Monthly Total Collected')
  };

  const yearlyData = {
    totalBilled: findValueByTitle('Yearly Total Billed'),
    totalCollected: findValueByTitle('Yearly Total Collected')
  };
  // Calculate collection rates
  const monthlyCollectionRate = monthlyData.totalBilled > 0 ? ((monthlyData.totalCollected / monthlyData.totalBilled) * 100).toFixed(2) : 0;

  const yearlyCollectionRate = yearlyData.totalBilled > 0 ? ((yearlyData.totalCollected / yearlyData.totalBilled) * 100).toFixed(2) : 0;
  const StatCard = ({ title, data, collectionRate, period }) => (
    <Card
      title={title}
      bordered={false}
      style={{
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        marginBottom: '16px'
      }}
      headStyle={{
        backgroundColor: '#fafafa',
        borderBottom: '1px solid #f0f0f0',
        fontWeight: 600
      }}
    >
      <Row gutter={[16, 16]}>
        <Col span={8}>
          <Statistic
            title="Total Billed"
            value={loading ? null : data.totalBilled || 0}
            formatter={loading ? () => <Spin size="small" /> : value => constructDisplayPrice(value, 'RM')}
            prefix={!loading && <DollarOutlined style={{ color: '#1890ff' }} />}
            valueStyle={{ color: '#1890ff', fontSize: '18px' }}
          />
        </Col>
        <Col span={8}>
          <Statistic
            title="Total Collected"
            value={loading ? null : data.totalCollected || 0}
            formatter={loading ? () => <Spin size="small" /> : value => constructDisplayPrice(value, 'RM')}
            prefix={!loading && <TrophyOutlined style={{ color: '#52c41a' }} />}
            valueStyle={{ color: '#52c41a', fontSize: '18px' }}
          />
        </Col>
        <Col span={8}>
          <Statistic
            title="Collection Rate"
            value={loading ? null : collectionRate}
            suffix={!loading && '%'}
            formatter={loading ? () => <Spin size="small" /> : undefined}
            prefix={!loading && <PercentageOutlined style={{ color: '#fa8c16' }} />}
            valueStyle={{
              color: collectionRate >= 80 ? '#52c41a' : collectionRate >= 60 ? '#fa8c16' : '#ff4d4f',
              fontSize: '18px'
            }}
          />
        </Col>
      </Row>
    </Card>
  );

  return (
    <div className="statistics-cards">
      <Row gutter={[24, 24]}>
        <Col xs={24} lg={12}>
          <StatCard title="Monthly Billing Statistics" data={monthlyData} collectionRate={monthlyCollectionRate} period="monthly" />
        </Col>
        <Col xs={24} lg={12}>
          <StatCard title="Yearly Billing Statistics" data={yearlyData} collectionRate={yearlyCollectionRate} period="yearly" />
        </Col>
      </Row>
    </div>
  );
};

export default StatisticsCard;
